import styled from "styled-components"
import { colors, tabletSize } from "../../constants"

const FooterDivider = styled.div`
  display: block;
  height: 1px;
  flex-shrink: 0;
  background-color: ${colors.very_very_light_two};
  @media (max-width: ${tabletSize}) {
    display: none;
  }
`

export default FooterDivider
